import { useSelector } from 'react-redux';
import Spinner from '../../../components/Spinner';
import HeaderRescuePortfolio from '../../../components/portfolio/rescuePortfolio/HeaderRescuePortfolio';
import RenderPortfolioRescue from '../../../components/portfolio/rescuePortfolio/RenderPortfolioRescue';
import { useGetClientInvestmentPortfoliosById } from '../../../hooks/useGetClientInvestmentPortfoliosById';
import { portfolioNameAndDetails } from '../../../utils/portfolioNameAndDetails';
import { numberWithPoint } from '../../../utils/utils';
import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';

const RescuePortfolio = () => {
  const portfolioSelectedById = useSelector(state => state.portfolio.portfolioSelected);

  const {
    data: dataPortfolioInvestmentId,
    loading: loadingGetPortfolioById,
    error: errorGetPortfolioById,
  } = useGetClientInvestmentPortfoliosById({
    accountId: portfolioSelectedById,
  });
  const successGetPortfolioById = dataPortfolioInvestmentId?.getClientInvestmentsPortfoliosById;

  if (loadingGetPortfolioById) {
    return <Spinner />;
  }
  if (errorGetPortfolioById) {
  }

  const porfolioDetails = successGetPortfolioById.find(
    porfolio => porfolio.id === '' && porfolio.name === '' && porfolio.security === '',
  );

  const amountMarketValueRescue = Math.round(Number.parseFloat(porfolioDetails?.marketValue));
  const porfolioDetailFileAs = successGetPortfolioById.find(
    portfolio => portfolio?.security.toLowerCase() === 'caja',
  );

  const portfolioFileAsComplete = portfolioNameAndDetails(porfolioDetailFileAs?.fileAs);

  const portfolioMarketValue = porfolioDetails?.marketValue;

  return (
    <>
      <HeaderLayout fileAs={portfolioFileAsComplete} type='product' isSimulatorFund={true} />

      <RenderPortfolioRescue
        typeProduct={'portfolio'}
        amountPortfolio={amountMarketValueRescue}
        portfolioFileAsComplete={portfolioFileAsComplete}
        marketValue={numberWithPoint(Number.parseFloat(portfolioMarketValue).toFixed(0))}
      />
    </>
  );
};

export default RescuePortfolio;
